export const types = {
  check: "check",
  integer: "integer",
  float: "float",
};
